import axiosInstance from "./axiosInstance";

export const emailTemplatesApi = {
  addEmailTemplate: async (payload) => {
    const response = await axiosInstance.post(
      `/EsignServices/email_templates/`,
      payload,
    );
    return response.data;
  },

  editEmailTemplate: async (payload, id) => {
    const response = await axiosInstance.put(
      `/EsignServices/email_templates/${id}/`,
      payload,
    );
    return response.data;
  },

  getAllEmailTemplates: async () => {
    const response = await axiosInstance.get(`/EsignServices/email_templates/`);
    return response.data;
  },

  getSingleEmailTemplate: async (id) => {
    const response = await axiosInstance.get(
      `/EsignServices/email_templates/${id}/`,
    );
    return response.data;
  },

  deleteEmailTemplate: async (id) => {
    const response = await axiosInstance.delete(
      `/EsignServices/email_templates/${id}/`,
    );
    return response.data;
  },
};
